module.exports = __webpack_public_path__ + "static/img/nodata.a8f47dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/nodata.png
// module id = olMA
// module chunks = 3